const chat ={
    methods: {
        ocultarChat(){
            setTimeout(()=>{
                let chat = document.getElementById("chat-application")
                
                if(chat == null) return;

                chat.style.visibility = "hidden"
            },2000);
            //alert("oculto")
        },
        mostrarChat(){
            setTimeout(()=>{
                let chat = document.getElementById("chat-application")

                if(chat == null) return;

                chat.style.visibility = "visible"
            },2000);
            //alert("mostrar")
        }
    },
}


export default chat;